export default "__VITE_ASSET__34a90d08__"